import React from 'react';
import { useTranslation } from 'react-i18next';
import 'features/navigation/footer/Footer.scss';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="navbar navbar-expand">
      <ul className="navbar-nav">
        <li className="nav-item">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://act.org/terms"
            className="navbar-link pt-2 pb-2">
            {t('footer.labelTerms')}
          </a>
        </li>
        <li className="nav-item ">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="http://act.org/privacy"
            className="navbar-link pt-2">
            {t('footer.labelPolicy')}
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
